module.exports = __webpack_public_path__ + "static/painter-7b2279e66fa6db323dbe15d630da03ac.jpg";